import { isDefault } from '../utils/template';

function LoadThemeComponent({ defaultView, baseView }) {
    if (isDefault()) {
        return defaultView();
    }
    return baseView();
}

export default LoadThemeComponent;
